/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Image
 */
export interface Image {
  /**
   *
   * @type {string}
   * @memberof Image
   */
  conversionName: ImageConversionNameEnum
  /**
   *
   * @type {string}
   * @memberof Image
   */
  url: string
  /**
   *
   * @type {number}
   * @memberof Image
   */
  width: number
  /**
   *
   * @type {number}
   * @memberof Image
   */
  height: number
}

/**
 * @export
 * @enum {string}
 */
export enum ImageConversionNameEnum {
  Original = 'original',
  Pc = 'pc',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

/**
 * Check if a given object implements the Image interface.
 */
export function instanceOfImage(value: object): value is Image {
  if (!('conversionName' in value) || value['conversionName'] === undefined)
    return false
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('width' in value) || value['width'] === undefined) return false
  if (!('height' in value) || value['height'] === undefined) return false
  return true
}

export function ImageFromJSON(json: any): Image {
  return ImageFromJSONTyped(json, false)
}

export function ImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Image {
  if (json == null) {
    return json
  }
  return {
    conversionName: json['conversionName'],
    url: json['url'],
    width: json['width'],
    height: json['height'],
  }
}

export function ImageToJSON(value?: Image | null): any {
  if (value == null) {
    return value
  }
  return {
    conversionName: value['conversionName'],
    url: value['url'],
    width: value['width'],
    height: value['height'],
  }
}
